import { render, staticRenderFns } from "./piechart.vue?vue&type=template&id=7aaa5f5a&scoped=true&v-once=true"
import script from "./piechart.vue?vue&type=script&lang=js"
export * from "./piechart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaa5f5a",
  null
  
)

export default component.exports